import { ArrowLeftIcon, Lock } from "lucide-react";
import { useRef, useState } from "react";
import { NavLink as Link } from "react-router-dom";
import { endpoints } from "../../hooks/endpoints";
import Spinner from "../Spinner";
import { Button } from "../ui/button";

const PasswordReset = () => {
  const emailRef = useRef("");
  const resKeyRef = useRef("");
  const passRef = useRef("");
  const [msg, setMsg] = useState<string>("");
  const [stepOneComplete, setStepOneComplete] = useState(false);
  const [passwordHasBeenReset, setPasswordHasBeenReset] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const submitEmail = (e) => {
    setIsPending(true);
    setMsg("");
    e.preventDefault();
    fetch(`${endpoints.getPassResetKey}?email=${emailRef.current.value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMsg(result.data);
        setStepOneComplete(result.success);
      })
      .catch((error) => {
        setMsg(error.data);
        setStepOneComplete(error.success);
      })
      .finally(() => setIsPending(false));
  };

  const submitResKey = (e) => {
    setIsPending(true);
    setMsg("");
    e.preventDefault();
    fetch(
      `${endpoints.changePassWithResetKey}?email=${emailRef.current.value}&new_pass=${passRef.current.value}&reset_key=${resKeyRef.current.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        setMsg(result.data);
        setPasswordHasBeenReset(true);
      })
      .catch((error) => {
        setMsg(error.data);
      })
      .finally(() => setIsPending(false));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-(--secondary-color)/10 to-yellow-50 flex items-start justify-center">
      <div className="rounded-lg p-2 bg-light container password-reset border mt-30 bg-white shadow-lg">
        <div className="fex my-2">
          <h2 className="m-auto text-primary text-xl border-b-2 border-(--primary-color-light) w-fit pb-2 flex gap-3">
            إسترجاع كلمة المرور
            <Lock className="inline-block" />
          </h2>
        </div>
        <div className="flex my-2">
          <form
            className="w-3/4 m-auto space-y-4"
            style={{ display: stepOneComplete ? "none" : "" }}
            onSubmit={submitEmail}
          >
            <div className="flex flex-col gap-2 my-4">
              <label htmlFor="floatingInput" className="text-primary">
                إكتب البريد الإلكتروني
              </label>
              <input
                ref={emailRef}
                type="email"
                className="py-2 px-3 rounded-lg border border-(--primary-color-light)"
                id="floatingInput"
                required
              />
            </div>
            <Button
              type="submit"
              className="rounded-lg w-full"
              disabled={isPending}
            >
              {isPending ? <Spinner variant="button" /> : "تعيين كلمة سر جديدة"}
            </Button>
          </form>
          {stepOneComplete && (
            <form className="w-3/4 m-auto space-y-4" onSubmit={submitResKey}>
              <div className="flex flex-col gap-2">
                <label htmlFor="otp" className="text-primary">
                  رمز التغيير (هتلاقيه على الإيميل)
                </label>
                <input
                  required
                  type="text"
                  ref={resKeyRef}
                  className="py-2 px-3 rounded-lg border border-(--primary-color-light)"
                  id="otp"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label htmlFor="newpass" className="text-primary">
                  كلمة المرور الجديدة
                </label>
                <input
                  required
                  type="password"
                  ref={passRef}
                  className="py-2 px-3 rounded-lg border border-(--primary-color-light)"
                  id="newpass"
                />
              </div>
              <Button
                type="submit"
                className="rounded-lg w-full"
                disabled={isPending || passwordHasBeenReset}
              >
                {isPending ? <Spinner variant="button" /> : "تغيير كلمة المرور"}
              </Button>
            </form>
          )}
        </div>
        <div className="flex my-4">
          <Link to="/" className="m-auto text-primary flex items-center gap-2">
            الرجوع للصفحة الرئيسية
            <ArrowLeftIcon className="size-5" />
          </Link>
        </div>
        {msg && (
          <div className="flex my-2">
            <div
              className={`border rounded-lg p-3 w-3/4 m-auto ${
                msg === "تم تغيير كلمة المرور"
                  ? "border border-green-400 bg-green-100 text-green-600"
                  : msg === "تم إرسال الرمز الى الإيميل"
                  ? "border border-yellow-500 bg-yellow-100 text-yellow-700"
                  : "border border-red-400 bg-red-100 text-red-600"
              }`}
            >
              {String(msg)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordReset;
